import React, { FunctionComponent as FC } from "react";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import Stack, { StackProps } from "@rui/Stack";

export const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "column",
  alignItems: "stretch",
  minHeight: "100vh",
  flexGrow: "1",
  backgroundColor: "#fff",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const Column = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "100%",

  [theme.breakpoints.up("md")]: {
    alignItems: "center",
    minHeight: "100vh",
  },
}));

export const LeftColumn = styled(Column)(({ theme }) => ({
  backgroundColor: "#f7f9ff",
  paddingTop: "40px",
  [theme.breakpoints.up("md")]: {
    flexShrink: 0,
    maxWidth: "412px",
    paddingTop: 0,
    justifyContent: "flex-end",
  },
}));

export const LeftColumnContent = styled(Column)({
  maxWidth: "720px",
  flexGrow: 1,
  justifyContent: "center",
});

export const RightColumn = styled(Column)(({ theme }) => ({
  flexGrow: 1,
  [theme.breakpoints.up("md")]: {
    justifyContent: "flex-start",
    width: "100%",
  },
}));

export const RightColumnContent = styled(Column)({
  maxWidth: "100%",
  flexGrow: 1,
  justifyContent: "center",
});

export const ProgressTitle = styled<FC<TypographyProps>>((props) => (
  <Typography variant="h2" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.primary[500],
  fontWeight: 500,
  fontSize: "21px",
  lineHeight: "25px",
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
  },
}));

export const ProgressDescription = styled<FC<TypographyProps>>((props) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  textAlign: "center",
  fontSize: "0.875rem",
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
  },
}));

export const ProgressContainer = styled(Stack)(({ theme }) => ({
  padding: "0px 20px 20px",
  alignItems: "center",
  rowGap: theme.spacing(4),
  columnGap: theme.spacing(4),
  width: "100%",
  flex: 1,
  [theme.breakpoints.up("md")]: {
    padding: "24px 60px",
    alignItems: "flex-start",
    rowGap: theme.spacing(5),
    columnGap: theme.spacing(5),
  },
}));

export const ProgressInnerContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  justifyContent: "center",

  rowGap: theme.spacing(4),
  columnGap: theme.spacing(4),
}));

export const ProgressStepContainer = styled(
  ({ numSteps: _, ...props }: StackProps & { numSteps: number }) => (
    <Stack spacing={3} {...props} />
  )
)(({ numSteps, theme }) => ({
  position: "relative",
  flexDirection: "row",
  justifyContent: "center",
  width: "100%",
  alignSelf: "center",
  // TODO: instead of numSteps can we simply count children?
  maxWidth: `${Math.max(numSteps, 1) * 60}px`,

  [theme.breakpoints.up("md")]: {
    flexDirection: "column",
    width: "auto",
    alignSelf: "normal",
    maxWidth: "100%",
  },
}));
